import { Link, useLocation } from "react-router-dom";
import { Home, Car, Calendar, User } from "lucide-react";

/**
 * Mobile bottom navigation for passenger — 4 tabs.
 * Only rendered on the passenger routes; hidden on sm+ where the desktop layout takes over.
 */
const TABS = [
  { key: "home", label: "Accueil", icon: Home, to: "/passenger", match: ["/passenger"] },
  { key: "trajets", label: "Trajets", icon: Car, to: "/passenger?tab=vehicles", match: [] },
  { key: "reservations", label: "Réservations", icon: Calendar, to: "/passenger?tab=bookings", match: [] },
  { key: "profil", label: "Profil", icon: User, to: "/passenger?tab=profile", match: [] },
];

export default function PassengerBottomNav() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "home";

  const isActive = (t) => {
    if (t.key === "reservations") return location.pathname === "/passenger" && activeTab === "bookings";
    if (t.key === "profil") return location.pathname === "/passenger" && activeTab === "profile";
    if (t.key === "trajets") return location.pathname === "/passenger" && activeTab === "vehicles";
    if (t.key === "home") return location.pathname === "/passenger" && (activeTab === "home" || !params.get("tab"));
    return false;
  };

  // Rewire nav for trajets and home
  const linkFor = (t) => {
    if (t.key === "home") return "/passenger";
    if (t.key === "trajets") return "/passenger?tab=vehicles";
    return t.to;
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E2E8F0] sm:hidden pb-safe"
      data-testid="passenger-bottom-nav"
    >
      <ul className="grid grid-cols-4">
        {TABS.map((t) => {
          const active = isActive(t);
          const Icon = t.icon;
          return (
            <li key={t.key}>
              <Link
                to={linkFor(t)}
                className={`flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
                  active ? "text-[#0A2540]" : "text-[#94A3B8] hover:text-[#0A2540]"
                }`}
                data-testid={`bottom-nav-${t.key}`}
              >
                <span
                  className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
                    active ? "bg-[#0A2540] text-white" : "bg-transparent"
                  }`}
                >
                  <Icon className="w-4 h-4" />
                </span>
                <span className={`text-[10px] font-medium ${active ? "text-[#0A2540]" : "text-[#94A3B8]"}`}>
                  {t.label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
